import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Additieven',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfaam K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucralose',
    [ProductAdditives.Aesculin]: 'Aesculine',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Anthocyanine',
    [ProductAdditives.Antioxidant]: 'Antioxidant',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioxidant: Ascorbinezuur',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioxidant: Tocoferolen',
    [ProductAdditives.Flavor]: 'Smaakstof',
    [ProductAdditives.Flavors]: 'Smaakstoffen',
    [ProductAdditives.AscorbicAcid]: 'Ascorbinezuur',
    [ProductAdditives.Aspartame]: 'Aspartaam',
    [ProductAdditives.OysterSauce]: 'Oestersaus',
    [ProductAdditives.BakingAid]: 'Bakhulpmiddel',
    [ProductAdditives.BakingPowder]: 'Bakpoeder',
    [ProductAdditives.BalsamicVinegar]: 'Balsamicoazijn',
    [ProductAdditives.BalsamicCream]: 'Balsamicocrème',
    [ProductAdditives.BasilPesto]: 'Basilicumpesto',
    [ProductAdditives.BenzoicAcid]: 'Benzoëzuur',
    [ProductAdditives.BetaCarotene]: 'Bètacaroteen',
    [ProductAdditives.Betain]: 'Betaïne',
    [ProductAdditives.BeetrootRed]: 'Bietenrood',
    [ProductAdditives.Beeswax]: 'Bijenwas',
    [ProductAdditives.Bitters]: 'Bitters',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Blue Curaçao-siroop',
    [ProductAdditives.BrandyVinegar]: 'Brandewijnazijn',
    [ProductAdditives.Broth]: 'Bouillon',
    [ProductAdditives.Caffeine]: 'Cafeïne',
    [ProductAdditives.Calcium]: 'Calcium',
    [ProductAdditives.Caramel]: 'Karamel',
    [ProductAdditives.CaramelColor]: 'Karamelkleur',
    [ProductAdditives.CaramelE150d]: 'Karamel E150d',
    [ProductAdditives.Carotene]: 'Caroteen',
    [ProductAdditives.CayennePepper]: 'Cayennepeper',
    [ProductAdditives.Chili]: 'Chili',
    [ProductAdditives.ChiliDressing]: 'Chilidressing',
    [ProductAdditives.ChiliMayonnaise]: 'Chilimayonaise',
    [ProductAdditives.ChiliOil]: 'Chiliolie',
    [ProductAdditives.Quinine]: 'Kinine',
    [ProductAdditives.Chlorophyll]: 'Chlorofyl',
    [ProductAdditives.CitricAcid]: 'Citroenzuur',
    [ProductAdditives.CitrusAcid]: 'Citruszuur',
    [ProductAdditives.CarbonDioxide]: 'Kooldioxide (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Cocktailsaus',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Currypasta',
    [ProductAdditives.CurryPowder]: 'Currypoeder',
    [ProductAdditives.CurryCreamSauce]: 'Curryroomsaus',
    [ProductAdditives.Fragrance]: 'Geurstof',
  },
};
